import * as React from "react";
const SvgColorPicker20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M17.707 2.293a3.121 3.121 0 0 0-4.414 0L11.5 4.086l-1.5-1.5L7.086 5.5l1.5 1.5-6.029 6.029-.736 5.15 5.15-.736L13 11.414l1.5 1.5L17.414 10l-1.5-1.5 1.793-1.793a3.121 3.121 0 0 0 0-4.414ZM10 8.414 11.586 10l-5.558 5.557-1.85.264.265-1.85L10 8.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgColorPicker20Px;
